import { all, takeEvery, put, call, select } from 'redux-saga/effects'
import { notification } from 'antd'
import {history, store as reduxStore} from 'index'
import * as firebase from 'services/firebase'
import * as jwt from 'services/jwt'
import actions from './actions'
import {currentAccount, email_login, forgot_password, login, myobLogin, logout} from "../../services/firebase";

// const DEFAULT_ENVIRONMENT = 'sandbox'
const DEFAULT_ENVIRONMENT = 'test'
// const DEFAULT_ENVIRONMENT = 'autodev'

const mapAuthProviders = {
  firebase: {
    login: firebase.login,
    register: jwt.register,
    currentAccount: firebase.currentAccount,
    logout: firebase.logout,
  },
  jwt: {
    login: jwt.login,
    register: jwt.register,
    currentAccount: jwt.currentAccount,
    logout: jwt.logout,
  },
}


export function* LOGIN({ payload }) {
  const { email, password } = payload
  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: true,
    },
  })
  // const { authProvider: autProviderName } = yield select(state => state.settings)
  const success = yield call(login, email, password)
  if (success) {
    yield put({
      type: 'user/LOAD_CURRENT_ACCOUNT',
    })
    yield history.push('/')
    notification.success({
      message: 'Logged In',
      description: 'You have successfully logged in!',
    })
  }
  if (!success) {
    yield put({
      type: 'user/SET_STATE',
      payload: {
        loading: false,
      },
    })
  }
}

export function* MYOB_LOGIN() {
  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: true,
    },
  })
  const success = yield call(myobLogin)
  if (success) {
    yield put({
      type: 'user/LOAD_CURRENT_ACCOUNT',
    })
    yield history.push('/')
    notification.success({
      message: 'Logged In',
      description: 'You have successfully logged in!',
    })
  }
  if (!success) {
    yield put({
      type: 'user/SET_STATE',
      payload: {
        loading: false,
      },
    })
  }
}

export function* EMAIL_LOGIN({ payload }) {
  console.log('payload EMAIL_LOGIN', payload)
  const { email, password } = payload
  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: true,
    },
  })
  // const { authProvider: autProviderName } = yield select(state => state.settings)
  const success = yield call(email_login, email, password)
  if (success) {
    yield put({
      type: 'user/LOAD_CURRENT_ACCOUNT',
    })
    yield history.push('/')
    notification.success({
      message: 'Logged In',
      description: 'You have successfully logged in!',
    })
  }
  if (!success) {
    yield put({
      type: 'user/SET_STATE',
      payload: {
        loading: false,
      },
    })
  }
}

export function* FORGOT_PASSWORD({ payload }) {
  console.log('payload FORGOT_PASSWORD', payload)
  const { email } = payload
  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: true,
    },
  })
  const success = yield call(forgot_password, email)
  if (success) {
    yield put({
      type: 'user/LOAD_CURRENT_ACCOUNT',
    })
    yield history.push('/')
    notification.success({
      message: 'Success',
      description: 'Reset password email sent',
    })
  }
  if (!success) {
    yield put({
      type: 'user/SET_STATE',
      payload: {
        loading: false,
      },
    })
  }
}


export function* REGISTER({ payload }) {
  const { email, password, name } = payload
  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: true,
    },
  })
  const { authProvider } = yield select(state => state.settings)
  const success = yield call(mapAuthProviders[authProvider].register, email, password, name)
  if (success) {
    yield put({
      type: 'user/LOAD_CURRENT_ACCOUNT',
    })
    yield history.push('/')
    notification.success({
      message: 'Succesful Registered',
      description: 'You have successfully registered!',
    })
  }
  if (!success) {
    yield put({
      type: 'user/SET_STATE',
      payload: {
        loading: false,
      },
    })
  }
}

export function* SWITCH_PROFILE({ payload }) {
  const response = yield call(currentAccount);

  if (response && response.email) {
    const { details } = response
    yield put({
      type: 'user/SET_STATE',
      payload: {
        ...details
      },
    })
  }
}

export function* LOAD_CURRENT_ACCOUNT() {
  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: true,
    },
  })

  const response = yield call(currentAccount);

  if (response && response.email) {
    const { id, email, name, avatar, role, details, userId, demoUser } = response

    yield put({
      type: 'user/SET_STATE',
      payload: {
        id,
        name,
        email,
        avatar,
        role,
        userId,
        demoUser,
        ...details,
        authorized: true,
      },
    })
  }

  yield put({
    type: 'user/SET_STATE',
    payload: {
      partnerLogo: "/favicon.png",
      loading: false
    },
  })


  yield reduxStore.dispatch({
    type: 'settings/CHANGE_SETTING',
    payload: {
      setting: 'environment',
      value: DEFAULT_ENVIRONMENT,
    },
  })

  yield put({
    type: 'settings/SET_PRIMARY_COLOR',
    payload: {
      color: '#4b53bc'
    }
  })

  yield history.push('/')

  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: false,
    },
  })
}

export function* LOGOUT() {
  yield call(logout);
  yield put({
    type: 'user/SET_STATE',
    payload: {
      id: '',
      name: '',
      role: '',
      email: '',
      avatar: '',
      authorized: false,
      loading: false,
    },
  })
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.LOGIN, LOGIN),
    takeEvery(actions.MYOB_LOGIN, MYOB_LOGIN),
    takeEvery(actions.EMAIL_LOGIN, EMAIL_LOGIN),
    takeEvery(actions.FORGOT_PASSWORD, FORGOT_PASSWORD),
    takeEvery(actions.REGISTER, REGISTER),
    takeEvery(actions.LOAD_CURRENT_ACCOUNT, LOAD_CURRENT_ACCOUNT),
    takeEvery(actions.SWITCH_PROFILE, SWITCH_PROFILE),
    takeEvery(actions.LOGOUT, LOGOUT),
   LOAD_CURRENT_ACCOUNT(), // run once on app load to check user auth
  ])
}
